import { render } from "./DocOverview.vue?vue&type=template&id=3ff62a24"
import script from "./DocOverview.vue?vue&type=script&lang=js"
export * from "./DocOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__